import moment from 'moment/moment';
import BookingTypes from '../../Constants/booking-types';
import { Booking } from '../../Hooks/types/booking';

export const formatTime = (booking: Booking) => {
  const isBlock = booking.type === BookingTypes.BLOCK;
  return isBlock
    ? `${moment.utc(booking.starts_at).format('hh:mm A')} - ${moment
        .utc(booking.ends_at)
        .format('hh:mm A')}`
    : moment.utc(booking.starts_at).format('hh:mm A');
};

export const formatDate = (booking: Booking) => {
  const isBlock = booking.type === BookingTypes.BLOCK;
  return isBlock
    ? `${moment.utc(booking.starts_at).format('MM/DD/YYYY')} - ${moment
        .utc(booking.ends_at)
        .format('MM/DD/YYYY')}`
    : moment.utc(booking.starts_at).format('MM/DD/YYYY');
};
